import { currentLocale, getSupportedLocales } from '@/plugins/i18n';

function getTranslation(field: Record<string, Record<string, string>>, key: string): string {
  if (!field[key]) return '[MISSING]';
  const locale = currentLocale();
  // TODO COCO-1796: Filter by obj language enabled
  // TODO COCO-1622: Add default language as fallback
  const otherLocale = getSupportedLocales().filter((x) => x != locale)[0];
  return field?.[key]?.[locale] || field?.[key]?.[otherLocale];
}

function isOverflown(text: string, count: number): boolean {
  if (!text) return false;
  return text.length > count;
}

export { getTranslation, isOverflown };
